export default "__VITE_ASSET__C9Y0M8s6__"